var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLitterBreederNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "litter_breeder_notes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "litter_breeder_notes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.4,157.58V577.49c0,12.44-10.33,22.51-23.07,22.51H66.07C53.33,600,43,589.93,43,577.49V23.68C43,11.23,53.33,1.16,66.07,1.16h326a23.61,23.61,0,0,1,7.82,1.33L550.33,148.26A22,22,0,0,1,552.4,157.58Z",
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.33,148.26H423.23a23.09,23.09,0,0,1-23.32-22.84V2.49Z",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.38,
    y: 294.36,
    width: 350.68,
    height: 48.86,
    rx: 24.43,
    transform: "matrix(1, -0.01, 0.01, 1, -2.41, 2.23)",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.87,
    y: 489.81,
    width: 349.51,
    height: 48.86,
    rx: 24.43,
    transform: "translate(-3.9 2.25) rotate(-0.44)",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.13,
    y: 392.09,
    width: 349.65,
    height: 48.86,
    rx: 24.43,
    transform: "translate(-3.16 2.24) rotate(-0.44)",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.08,135.91c4.85-.43,12.71.55,17.19,2.52a55.45,55.45,0,0,1,10.43,6.14A105.34,105.34,0,0,1,263.9,162a154.88,154.88,0,0,1,22.9,36.09A80.1,80.1,0,0,1,293.2,218a37.22,37.22,0,0,1,.49,8,15.63,15.63,0,0,1-5.8,11.64,28.94,28.94,0,0,1-15,6.58,57,57,0,0,1-17.82-.75c-7.6-1.35-15-3.59-22.41-5.6-2.2-.59-4.43-1.08-6.65-1.63a20,20,0,0,0-10.43.23c-5.44,1.54-10.88,3.12-16.31,4.69a110.07,110.07,0,0,1-19.58,4.16,39.6,39.6,0,0,1-16.79-1.49,26.19,26.19,0,0,1-11.21-7.34,14.28,14.28,0,0,1-3.35-8.19,39.35,39.35,0,0,1,1.17-13.79,106.37,106.37,0,0,1,9.69-24.93,152.28,152.28,0,0,1,24.75-34.93,79.28,79.28,0,0,1,16.4-13.54A34.52,34.52,0,0,1,213,136.24a28,28,0,0,1,3.54-.29C218.08,135.91,216.47,135.9,218.08,135.91Z",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.13,89.08a49.93,49.93,0,0,1-2.47,15,58.92,58.92,0,0,1-8.43,17.15,27.62,27.62,0,0,1-6.87,7,17.65,17.65,0,0,1-17.65,1.64,26.41,26.41,0,0,1-11.54-9.79,37.56,37.56,0,0,1-6.89-21.68c0-9.12,3.39-16.92,9.49-23.58a41.23,41.23,0,0,1,14.55-10.43,25,25,0,0,1,9.41-2.09c6.53-.07,11.55,2.76,15.27,8,3.21,4.5,4.56,9.68,5,15.11.06.62.09,1.24.11,1.85S279.13,88.46,279.13,89.08Z",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.53,90.1c.1-6.77,1-12.18,3.85-17.14s6.84-8.39,12.54-9.51a20.91,20.91,0,0,1,11.45,1c11.07,4.15,19.27,11.43,23.92,22.39a32.55,32.55,0,0,1,1.8,18.77,37.12,37.12,0,0,1-8.63,18.29,23.45,23.45,0,0,1-11.41,7.48A17.54,17.54,0,0,1,177,128.2a36.66,36.66,0,0,1-9.19-11.08,59.38,59.38,0,0,1-7.61-20.93C159.79,93.8,159.66,91.38,159.53,90.1Z",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.51,149.45A25.19,25.19,0,0,1,165,164.23c-4.54,6.31-11.69,9.37-20.28,7a42,42,0,0,1-13.28-6.61,39.88,39.88,0,0,1-10.92-11.42,24.27,24.27,0,0,1-4-13.84,16.36,16.36,0,0,1,8.58-14.23,25.24,25.24,0,0,1,10.51-3.17,35.84,35.84,0,0,1,19.51,3.31,24.56,24.56,0,0,1,13.56,17.29c.53,2.25.7,4.59,1,6.89Z",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.29,120c4.33.16,8.7.78,12.72,3,6.06,3.29,9.08,8.41,9.15,15.26a24.34,24.34,0,0,1-4.48,14,43.7,43.7,0,0,1-22.43,17.15,18.21,18.21,0,0,1-10.88.65,18,18,0,0,1-12.17-10.22c-4.7-10.22-3.83-20.1,2.85-29.23,3.3-4.5,8-7.14,13.28-8.82A40.3,40.3,0,0,1,302.29,120Z",
    fill: "#00a0df"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitterBreederNotes);
export default __webpack_public_path__ + "static/media/litter_breeder_notes.8edcb0902a1e00a743e74680790ff8a1.svg";
export { ForwardRef as ReactComponent };